import React from 'react';
import { MailCheck } from 'lucide-react';
import { FactRow, KeyValueList } from '@ajat/design-system/FactRow';
import { ComponentPage, DemoCard } from '../../shared';

export const meta = {
  title: 'Fact Row',
  group: 'Data display',
  importPath: '@ajat/design-system/FactRow',
  description:
    'Read-only facts. FactRow is one label-over-value entry (the account e-mail that is shown, never edited); KeyValueList the label / value rows of an order summary with an optional total.',
  propSets: [
    {
      title: 'FactRow',
      component: FactRow,
      componentName: 'FactRow',
      rows: [
        ['icon', 'node', '—', 'Leading icon, 20px'],
        ['label', 'node', '—', 'Small muted label (dt)'],
        ['value', 'node', '—', 'The fact (dd)'],
        ['helper', 'node', '—', 'Muted line under the value'],
        ['boxed', 'bool', 'false', 'Hairline box around the row'],
        ['className', 'string', "''", 'Additional CSS class'],
      ],
    },
    {
      title: 'KeyValueList',
      component: KeyValueList,
      componentName: 'KeyValueList',
      rows: [
        ['rows', "[{ label, value, variant }]", '[]', "Rows; variant 'discount' (success tone) or 'muted'"],
        ['total', '{ label, value }', '—', 'Final row behind a hairline, at H5'],
        ['dividers', 'bool', 'false', 'Hairline between every row (colour: the --kv-divider-color hook, gray-1 by default)'],
        ['size', "'regular' | 'small'", "'regular'", 'small = compact breakdown rows: gray-7 (a Price value follows), small-m above and below each row; the total keeps H5'],
        ['className', 'string', "''", 'Additional CSS class'],
      ],
    },
  ],
  usage: [
    {
      title: 'An order summary',
      code: `import { FactRow, KeyValueList } from '@ajat/design-system/FactRow';

<FactRow boxed icon={<MailCheck size={20} />} label="Kontots e-post" value="kim@example.se" helper="Kan inte ändras" />

<KeyValueList
  rows={[{ label: 'Produkter', value: '1 469:-' }, { label: 'Rabatt 15%', value: '-220:-', variant: 'discount' }]}
  total={{ label: 'Totalt', value: '1 249:-' }}
/>`,
    },
  ],
};

export default function FactRowPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="FactRow">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-ui-medium-s)', maxWidth: 480 }}>
          <FactRow label="Leveransadress" value="Sibyllegatan 47, 114 42 Stockholm" />
          <FactRow boxed icon={<MailCheck size={20} />} label="Kontots e-post" value="kim@example.se" helper="Det här är din inloggning – den kan inte ändras." />
        </div>
      </DemoCard>
      <DemoCard title="KeyValueList">
        <div style={{ maxWidth: 360 }}>
          <KeyValueList
            rows={[
              { label: 'Produkter', value: '1 469:-' },
              { label: 'Paket', value: '500:-' },
              { label: 'Rabatt 15%', value: '-220:-', variant: 'discount' },
              { label: 'Frakt', value: '0:-', variant: 'muted' },
            ]}
            total={{ label: 'Totalt', value: '1 749:-' }}
          />
        </div>
      </DemoCard>
      <DemoCard title="KeyValueList — size small, dividers (a design's contents)">
        <div style={{ maxWidth: 360 }}>
          <KeyValueList
            size="small"
            dividers
            rows={[
              { label: 'Overall, Vit', value: '299 kr' },
              { label: 'Vanlig patch × 9', value: '261 kr' },
              { label: 'Textpatch', value: '294 kr' },
            ]}
            total={{ label: 'Summa', value: '854 kr' }}
          />
        </div>
      </DemoCard>
    </ComponentPage>
  );
}
